import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import ResumenGuiaContent from "./ResumenGuiaContent"

interface ChildsProps {
    logout: () => void
    autenticado: boolean
}


const ConsultaGuia: React.FC<ChildsProps> = ({logout, autenticado}) => {


    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            <ResumenGuiaContent autenticado={autenticado}/>
        </div>

    </div>
    )
}


export default ConsultaGuia